"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var likelihood = ["Not at all likely", "1", "2", "3", "4", "5 - Neutral", "6", "7", "8", "9", "Extremely likely"];
var ROIoptions = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];

var likelihoodFn = function likelihoodFn(n) {
  return n * 100 / (likelihood.length - 1);
};

var slider = ["0", "1", "2", "3", "4", "5", "6", "7"];
var questions = screenersImport.expandscreeners([{
  prompt: "This self-assessment takes 5 minutes to complete, and will provide you " + "with a snapshot of your mental fitness alongside global averages. Your responses  " + "are stored securely, confidential between you and your coach, and will never be used " + "to identify you to a third party.",
  type: "multi",
  options: [],
  intro: true,
  optional: true,
  aggregated: true,
  batteryId: "survey"
}, // Demographics
{
  prompt: "What is your gender?",
  type: "multi",
  options: ["Male", "Female", "Other"],
  key: "gender",
  eval: function _eval(n, q) {
    return q.options[n];
  },
  batteryId: "survey"
}, {
  prompt: "What is your age?",
  extraText: "",
  type: "single",
  optional: false,
  key: "age",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "What is your degree?",
  extraText: "",
  type: "single",
  optional: false,
  key: "degree",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, // Company support and cohesion
{
  prompt: "What year of your degree are you currently in?",
  extraText: "",
  type: "single",
  optional: false,
  key: "yearDegree",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "Are you studying part-time or full-time?",
  extraText: "",
  type: "multi",
  options: ["Part-time", "Full-time"],
  optional: false,
  key: "yearDegree",
  eval: function _eval(n) {
    return n;
  },
  batteryId: "survey"
}, {
  prompt: "Are you an international student?",
  extraText: "",
  type: "multi",
  options: ["Yes", "No"],
  key: "international",
  eval: function _eval(n, q) {
    return q.options[n];
  },
  batteryId: "survey"
}, {
  prompt: "On how many days in the past week have you felt so stressed or frustrated that you considered dropping out from your studies?",
  options: ROIoptions,
  aggregated: true,
  type: "dayslider",
  specific: true,
  batteryId: "survey",
  eval: function _eval(n) {
    return n;
  }
}]);

var analysis = function analysis(answers, numeric) {
  if (!answers) return null;
  var results = {};
  results.scales = {};
  results.humanReadable = {};
  questions.forEach(function (q, i) {
    if (!q.key) return;

    if (numeric) {
      results[q.key] = answers[i];
    } else {
      results[q.key] = q.eval(answers[i], q);
      results.humanReadable[q.prompt] = q.eval(answers[i], q);
    }
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis
};